module.exports = __webpack_public_path__ + "img/4.1e7a1304.png";